import { atom, useSetAtom, useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { queries } from 'services/queries';
import { useQuery } from '@tanstack/react-query';

export type ConversationCategoryType = 'mine' | 'all';

export const conversationCategoryState = atom<ConversationCategoryType>('mine');
export const useConversationCategory = () => useAtomValue(conversationCategoryState);
export const useSetConversationCategory = () => useSetAtom(conversationCategoryState);

export const useConversationCategoryEnable = () => {
  const { data } = useQuery(queries.stores.userStoreCount);

  return useMemo(() => {
    return data?.data?.data?.showAll;
  }, [data]);
};
